import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { AsrBanner } from "./AsrBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const IMAGE_MAP: Record<string, string> = {
  advice:
    "https://www.asr.nl/-/media/images/asr/asrnl/hypotheek/header-statershypotheek-2025_desktop.jpg",
  documentsOutgoing:
    "https://www.asr.nl/-/media/images/asr/asrnl/hypotheek/hypotheken-adviseurs-folder/hypotheek-rectangle-digithuis-hypotheek.jpg?mw=2000&hash=C38940BBF89E05F9FAF9253DC8BFC2F3",
  documentsIncoming:
    "https://www.asr.nl/-/media/images/asr/asrnl/hypotheek/hypotheken-adviseurs-folder/hypotheek-rectangle-digithuis-hypotheek.jpg?mw=2000&hash=C38940BBF89E05F9FAF9253DC8BFC2F3",
  interestRates:
    "https://www.asr.nl/-/media/images/asr/asrnl/blogs/hypotheek-voorwaarden.jpg",
  maximumMortgage:
    "https://www.asr.nl/-/media/images/asr/asrnl/leven/belastinginformatie.png",
  orientation:
    "https://www.asr.nl/-/media/images/asr/asrnl/hypotheek/hero-welthuis-hypotheek.jpg",
};

export const AsrPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();

  return (
    <AsrBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={IMAGE_MAP[scope] ?? ""}
    />
  );
};
